export default __webpack_public_path__ + "static/media/changeSymptom.514e4b6e.wav";